import { render } from "./PayFactorsStep.vue?vue&type=template&id=12d949ad&scoped=true"
import script from "./PayFactorsStep.vue?vue&type=script&lang=js"
export * from "./PayFactorsStep.vue?vue&type=script&lang=js"

import "./PayFactorsStep.vue?vue&type=style&index=0&id=12d949ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d949ad"]])

export default __exports__